import { memoryCache } from 'mihoyo-store';
import { CACHE_INSTANCE_ID, CACHE_USER_LIST } from '@configPath/cacheConfigs/memoryCache.config';
import customEvent from 'mihoyo-custom-event';
import BScroll from 'better-scroll'
import ClipboardJS from 'clipboard';
import model from '../../models/default';
import modal from '../modal';
import { START_LIST_RENDER, TO_TARGET } from '@configPath/eventConfigs/customEvent.config';
import tpl from './porn.tpl';
import main from '../main';

// memoryCache的存在仅仅是为了演示多个模块之间共享数据的方法，可删除相关代码
// const memoryCache = Store.getInstance();

export default {
  id: 0,
  page: 1,
  order: 'ctime',
  role: '0',
  detail: false,
  /**
   * 视图容器对象
   * @returns {jQuery|HTMLElement}
   */
  el() {
    return $('.porns');
  },

  options() {
    return $('.porn-select');
  },

  pornend() {
    return $('.porn-end');
  },

  pornsort() {
    return $('.porn-sort');
  },

  likeButton() {
    return $('.page-2-detail>.like');
  },

  shareButton() {
    return $('.share');
  },

  totop() {
    return $('.totop');
  },

  bigLikeNum() {
    return $('.page-2-detail>.porn-like>span');
  },

  /**
   * 视图渲染方法
   */
  render() {
    this.fetchList();
    this.events();
  },

  changeLikeBig() {
    this.likeButton().addClass('liked-big');
  },

  fetchList() {
    const { page, order, role, jumpId } = this;
    return model.getPornList({data:{page,order,role}}).then((data) => {
      if (data.is_show) {
        $('.page-2-bg-not').toggleClass('page-2-bg-not page-2-bg');
        if (!this.detail) {
          $('.page-2-list').css('display', 'block');
        }
      }
      if (data.form_info && data.form_info.length) {
        this.options().html('');
        const target = data.form_info.find(o => o.name === 'role');
        this.options().html(`<option value=0>全部</option>`);
        target ? target.option.forEach((item) => {
          this.options().append(`<option value=${item.id} ${item.id == role ?'selected="selected"':''}>${item.name}</option>`);
        }) : null;
      }
      if (data.list && data.list.length) {
        this.page += 1;
        this.el().append(template.render(tpl, data.list));
        main.imgSumHandler('.porns .porn-image-container');
        this.pornend().css('display', 'none');
      } else {
        this.pornend().css('display', 'block');
      }
    }).fail(main.handleFail);
  },

  reset() {
    this.page = 1;
    this.el().html('');
    this.fetchList();
  },

  like(id) {
    model.like({data:{id}}).then(() => {
      this.changeLikeBig();
      const likeNum = $(`.${id}`).find('span');
      if (likeNum.html() !== '999+' && likeNum.html() !== '1w+') {
        likeNum.html(parseInt(likeNum.html()) + 1);
      }
      this.bigLikeNum().html(parseInt(this.bigLikeNum().html()) + 1);
      $(`.${id}`).find('.porn-like-img').addClass('porn-like-img-active');
    }).fail(main.handleFail);
  },

  intoDetail(id) {
    model.getPornDetail({data:{id}}).then(({ is_show, is_like, post}) => {
      if (is_show) {
        if (is_like) {
          this.changeLikeBig();
        } else {
          this.likeButton().removeClass('liked-big').off('click').one('click', () => {
            this.like(id);
          });
        }
        this.renderDetail(post);
        this.detail = true;
        main.jump('.page-2-list', '.page-2-detail');
      } else {
        main.jump('.page-2', '.page-1');
      }
    }).fail(main.handleFail);
  },

  renderDetail(post) {
    const src = `${post.file_list[0]}?x-oss-process=image/resize,s_500/quality,q_80/auto-orient,0/interlace,1/format,jpg`;
    this.bigLikeNum().html(post.likes);
    $('.detail-img').html(main.imgHandler(src));
    $('.detail-title').html(post.title);
    $('.detail-author').html(`作者：${post.nickname}`);
    $('.detail-desc').html(post.desc);
  },

  /**
   * 视图事件集中绑定
   */
  events() {
    const bscroll = new BScroll('.porn-wrapper', {
      pullUpLoad: {
        threshold: 0
      },
      pullDownRefresh: {
        threshold: 0
      },
      preventDefaultException: {
        className: /(^|\s)(totop|porn-image-container|porn-like|porn-like-img)(\s|$)/
      }
    });
    const refreshBS = () => {
      setTimeout(function(){
        bscroll.refresh();
      }, 0);
    };
    bscroll.on('scroll', ({y}) => {
      if (y > -10) {
        this.totop().css('display', 'none');
      } else if (this.totop().css('display') === 'none') {
        this.totop().css('display', 'block');
      }
    });
    bscroll.on('pullingDown', () => {
      this.reset();
      bscroll.finishPullDown();
    });
    bscroll.on('pullingUp', () => {
      this.fetchList().then(() => {
        bscroll.finishPullUp();
        refreshBS();
      });
    });
    customEvent.on(TO_TARGET, ({id}) => {
      this.id = id;
      main.jump('.page-1', '.page-2');
      this.intoDetail(id);
    });
    customEvent.on(START_LIST_RENDER, () => {
      refreshBS();
    });
    this.pornsort().on('click', (e) => {
      this.pornsort().removeClass('porn-sort-active');
      $(e.target).addClass('porn-sort-active');
      this.order = e.target.classList[0];
      this.reset();
    });
    this.options().on('change', (e) => {
      this.role = $(e.target).find("option:selected").val();
      this.reset();
    });
    this.totop().on('click', () => {
      bscroll.scrollTo(0, 0, 2000);
    });
    this.el().on('click', '.porn-image-container', (e) => {
      this.id = $(e.target).parents('.porn-container')[0].classList[0];
      this.intoDetail(this.id);
    });
    $('.detail-img').on('click', 'img', (e) => {
      main.fs(e);
    });
    $('.detail-return').on('click', () => {
      this.detail = false;
      main.jump('.page-2-detail', '.page-2-list');
      window.scrollTo(0,0);
      refreshBS();
      this.changeLikeBig();
    });
    this.el().on('click', '.porn-like', (e) => {
      if ($(e.target).find('.porn-like-img-active').length === 0 && !$(e.target).hasClass('porn-like-img-active')) {
        this.like($(e.target).parents('.porn-container')[0].classList[0]);
      }
    });
    this.shareButton().on('click', () => {
      main.initClip(this.id);
      if(ClipboardJS.isSupported()){
        modal('.cancel-modal','赶快去粘贴，分享给好友吧！');
      }else{
        modal('.cancel-modal','复制遇到问题，舰长可以手动输入礼物码分享给好友~');
      }
    });
  }
}
